import style from './style.module.css'
import React from "react";
import { useEffect, useState } from "react";
import { useRef } from 'react';

import 'animate.css';


const INITIAL_DATA = {
    total: 0,
    current_page: 1,
    last_page: 1,
    first_page_url: "",
    last_page_url: "",
    next_page_url: "",
    prev_page_url: null,
    path: "",
    from: 1,
    to: 1,
    data: [],
  };

export default function Partners(props){


    const [partnersVisible, setPartnersVisible] = React.useState(2);
    const [showButton, setShowButton] = React.useState(4);
    window.addEventListener("resize", function(){
        if(this.window.innerWidth <= 900){
          if(window.innerWidth<=550){
            setPartnersVisible(4);
          }else{
            setPartnersVisible(6);

          }
            setShowButton(3);
        }
        else{
            setPartnersVisible(8);
            setShowButton(4);
        }
    });

    const visible = (()=>{
        if(window.innerWidth <= 900){
          if(window.innerWidth<=550){
            setPartnersVisible(4);
          }else{
            setPartnersVisible(6);

          }
            setShowButton(3);
        }
        else{

            setPartnersVisible(8);
            setShowButton(4);
        }
    })

    const refMore = useRef();
    const refLess = useRef();
    const refPartners = useRef();
    const refShadow = useRef();

    const showMore = () =>{
        fadeInDown();
        setPartnersVisible(props.partnersData.length);
        refMore.current.style.display = "none";
        refLess.current.style.display = "block";    
    }

    const showLess = () =>{


            fadeInUp();
            visible();
            refMore.current.classList.add("animate__animated");
            refMore.current.classList.add("animate__fadeInUp");
            refLess.current.style.display = "none";
            refMore.current.style.display = "block";

    }

    useEffect(() => {
        visible();
    }, []);

    function fadeInDown(){
        refPartners.current.classList.remove("animate__animated");
        refPartners.current.classList.remove("animate__fadeIn");
        refPartners.current.classList.add("animate__animated");
        refPartners.current.classList.add("animate__fadeInDown");
    }
    function fadeInUp(){
        refPartners.current.classList.remove("animate__animated");
        refPartners.current.classList.remove("animate__fadeInDown");
        refPartners.current.classList.add("animate__animated");
        refPartners.current.classList.add("animate__fadeIn");
        document.getElementById("PartnersPage").scrollIntoView();



    }



    return ( 
     <div >
    <div className={style.partnerspage} id="PartnersPage">
        <h1 className={style.title_partners}>NOSSOS PARCEIROS</h1>
    <div  id='partners' className={style.partners_list} ref={refPartners}>


        {props.partnersData.slice(0, partnersVisible).map((item) => (
          <div className={style.partners}>
            <div className={style.img_wrapper}>
              <img src={item.icon} alt="" className={style.partners_img}/>
            </div>
            <div className={style.name_border}>
              <p className={style.partners_name}> {item.name_partner}</p>
            </div>
          </div>
        ))}
                </div>
                {props.partnersData.length > showButton && (
                <>
                    <div className={style.showMore} ref={refMore}>
                        <div className ={style.sombra} ref={refShadow}>
                            <button id = "buttonMore" className={style.buttonMore} onClick={showMore}>VER MAIS</button>
                        </div>
                    </div>
                        
                    <div className={style.showLess} style = {{display:'none'}} ref={refLess}> 
                        <button id = "buttonLess" className={style.buttonLess} onClick={showLess}>VER MENOS</button>
                    </div>    
                </>
                )}
            </div>
     </div>

    )
}